export default function showEarlyAccessBanner(productData, isMixAndMatch) {
  if (!isMixAndMatch) {
    return isEligibleEarlyAccessProduct(productData);
  }

  return (
    productData?.products?.length > 0 &&
    productData.products.every(isEligibleEarlyAccessProduct)
  );
}

function isEligibleEarlyAccessProduct(product) {
  return ["view", "purchase"].includes(product?.earlyAccess?.customerAccess);
}
